import React from 'react';

import CourseRequestStatusBadge from '../../components/common/CourseRequestStatusBadge';
import Table from '../../components/common/Table';
import { CourseRequestDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface CourseRequestTableProps {
  data: CourseRequestDTO[];
  handleView: (row: CourseRequestDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

// No delete action: a request only leaves the queue by being approved or declined, so its history
// stays intact. "Edit" here opens the review screen.
const CourseRequestTable: React.FC<CourseRequestTableProps> = ({
  data,
  handleView,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => (
  <Table
    columns={[
      { label: 'Course', key: 'courseName' },
      { label: 'Country', key: 'countryName' },
      {
        label: 'State or province',
        key: 'stateName',
        // Requests sent before the form asked for a state only have the old free-text town.
        render: (row: CourseRequestDTO) => (
          <span>{row.stateName || row.location || '-'}</span>
        ),
      },
      { label: 'Requested by', key: 'memberName' },
      {
        label: 'Status',
        key: 'status',
        render: (row: CourseRequestDTO) => (
          <CourseRequestStatusBadge status={row.status} />
        ),
      },
      {
        label: 'Requested',
        key: 'createdUtc',
        format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
      },
    ]}
    data={data}
    actions={{
      onEdit: handleView,
    }}
    currentPage={currentPage}
    totalPages={totalPages}
    onPageChange={setCurrentPage}
    pageSize={pageSize}
    onPageSizeChange={setPageSize}
    isLoading={isLoading}
  />
);

export default CourseRequestTable;
